export default {"src":"/_next/static/media/download-icon.6646aaab.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};